import { authUserSchema } from "@/modules/auth/schemes";

const getPermissionSet = (user: unknown) => {
	const parsedUser = authUserSchema.safeParse(user);

	if (!parsedUser.success) {
		return new Set<string>();
	}

	const directPermissions = parsedUser.data.permissions;
	const rolePermissions = parsedUser.data.role.permissions;

	return new Set([...directPermissions, ...rolePermissions]);
};

export const hasPermission = (user: unknown, permission: string) => {
	const permissions = getPermissionSet(user);
	return permissions.has(permission);
};

export const hasSomePermission = (user: unknown, permissions: string[]) => {
	if (permissions.length === 0) {
		return true;
	}

	const permissionSet = getPermissionSet(user);
	return permissions.some((permission) => permissionSet.has(permission));
};
